import { Box, Skeleton } from "@mantine/core";
import React from "react";

const FilesTableSkeleton = () => {
  return (
    <Box>
      <Skeleton mt="md" mb="md" h={30} />
      <Skeleton h={160} />
    </Box>
  );
};

export default FilesTableSkeleton;
